import React, { FunctionComponent, PropsWithChildren } from "react";
import { Helmet } from "react-helmet";
import { Container, Spinner } from "react-bootstrap";

import HeaderRow from "./HeaderRow";

interface Props extends PropsWithChildren<any> {
  title: string;
  siteTitle: string;
  fullWith?: boolean;
  isLoading?: boolean;
}

const renderLoading = (
  <div className="d-flex justify-content-center align-items-center py-5">
    <div className="text-center">
      <Spinner animation="border" className="mb-3" style={{ color: "var(--primary)" }} />
      <p className="text-muted mb-0">Daten werden geladen...</p>
    </div>
  </div>
);

const renderTitle = (title: string, fullWith?: boolean): React.ReactNode => {
  if (fullWith) {
    return (
      <Container>
        <HeaderRow title={title} headingLevel={1} />
      </Container>
    );
  }

  return (
    <div>
      <HeaderRow title={title} headingLevel={1} />
    </div>
  );
};

export const ContentLayout: FunctionComponent<Props> = (props: Props) => {
  return (
    <Container fluid={props.fullWith} className="h-100 py-4">
      <div className="min-vh-100">
        <Helmet>
          <title>{props.siteTitle}</title>
        </Helmet>
        {renderTitle(props.title, props.fullWith)}
        {props.isLoading && renderLoading}
        {!props.isLoading && <div className="fade-in">{props.children}</div>}
      </div>
    </Container>
  );
};
